/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import ReactPlayer from 'react-player';

class Event202402_sul extends Component {
  state = {
    width: 0,
    height: 0,
  };
  componentDidMount = () => {
    setTimeout(() => {
      this._getSize();
    }, 500);

    window.addEventListener('resize', this._getSize);
  };
  componentWillUnmount = () => {
    window.removeEventListener('resize', this._getSize);
  };
  _getSize = () => {
    const img = document.getElementById('player');
    // console.log(img.width);
    const width = img.width;
    const height = width * (360 / 640);
    this.setState({
      width: width,
      height: height,
    });
    // console.log(width, height);
  };

  _onClose = () => {
    const { setEventIdx } = this.props;
    setEventIdx(0);
  };
  _go = () => {
    window.open('https://shop.aniplustv.com/item/9520', '', '');
  };
  render() {
    const { imgUrl } = this.props;
    const { width, height } = this.state;

    return (
      <Fragment>
        <div className="event_head">
          <h3>우마무스메 블루레이 기간 한정 판매</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: 'cursor' }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <img
              src={imgUrl + '/img/event/event20240206/event01.png'}
              alt=""
              id="player"
            />
            {/*
            <div style={{ textAlign: "center" }}>
              <ReactPlayer
                url={"http://www.youtube.com/watch?v=iqD5hxe-mkw"}
                playing
                controls
                width={width}
                height={height}
              />
            </div>
            */}
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202402_sul));
